import { Switch } from '../ui/switch';
import { BadgeAcces, Filtres, nomComplet, useFiltres } from './suiviCommun';

export const Interrupteur = ({ actif, onChange, titre, texte, testId }) => (
  <div className="flex items-start justify-between gap-4 rounded-xl bg-slate-50 p-4">
    <div>
      <p className="font-semibold text-[#0F172A]">{titre}</p>
      <p className="mt-0.5 text-sm text-slate-500">{texte}</p>
    </div>
    <Switch checked={actif} onCheckedChange={onChange} data-testid={testId} />
  </div>
);

const Choix = ({ actif, onClick, children, testId }) => (
  <button type="button" onClick={onClick} aria-pressed={actif} data-testid={testId}
    className={`rounded-full px-3.5 py-1.5 text-sm font-semibold transition-colors ${actif ? 'bg-[#0E7C74] text-white' : 'bg-white text-slate-600 ring-1 ring-slate-200 hover:bg-slate-100'}`}>
    {children}
  </button>
);

export const ChoixSessions = ({ cfg, sessions, maj }) => {
  const basculer = (s) => maj({ sessions: cfg.sessions.includes(s) ? cfg.sessions.filter((x) => x !== s) : [...cfg.sessions, s] });
  return (
    <div className="space-y-3 rounded-xl border border-slate-200 p-4" data-testid="guide-pilotage-sessions">
      <div className="flex flex-wrap gap-2">
        <Choix actif={cfg.toutes_sessions} onClick={() => maj({ toutes_sessions: true })} testId="guide-pilotage-toutes-sessions">Toutes les sessions</Choix>
        <Choix actif={!cfg.toutes_sessions} onClick={() => maj({ toutes_sessions: false })} testId="guide-pilotage-sessions-choisies">Sessions choisies</Choix>
      </div>
      {!cfg.toutes_sessions && (
        <div className="flex flex-wrap gap-2">
          {sessions.map((s) => <Choix key={s} actif={cfg.sessions.includes(s)} onClick={() => basculer(s)} testId={`guide-pilotage-session-${s}`}>Session {s}</Choix>)}
          {!sessions.length && <p className="text-sm text-slate-400">Aucune session trouvée</p>}
        </div>
      )}
    </div>
  );
};

const REGLES = [['session', 'Selon la règle générale'], ['ouvert', 'Toujours ouvert'], ['ferme', 'Toujours fermé']];
const regle = (v) => (v === true ? 'ouvert' : v === false ? 'ferme' : 'session');

export const Exceptions = ({ cfg, data, maj }) => {
  const f = useFiltres(data.stagiaires);
  const changer = (uid, v) => {
    const exceptions = { ...cfg.exceptions };
    if (v === 'session') delete exceptions[uid]; else exceptions[uid] = v === 'ouvert';
    maj({ exceptions });
  };
  return (
    <div className="space-y-4">
      <Filtres f={f} sessions={data.sessions} prefixe="guide-pilotage" />
      <ul className="divide-y divide-slate-100 rounded-xl border border-slate-200">
        {f.liste.map((s) => (
          <li key={s.user_id} className="flex flex-wrap items-center gap-3 px-4 py-3" data-testid={`guide-pilotage-ligne-${s.user_id}`}>
            <span className="w-full min-w-0 text-sm font-semibold text-[#0F172A] sm:w-auto sm:flex-1">{nomComplet(s)} <span className="font-normal text-slate-400">· {s.session ? `Session ${s.session}` : 'Sans session'}</span></span>
            <select value={regle(cfg.exceptions[s.user_id])} onChange={(e) => changer(s.user_id, e.target.value)} data-testid={`guide-pilotage-regle-${s.user_id}`}
              className="rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-sm">
              {REGLES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select>
            <BadgeAcces ok={s.acces} testId={`guide-pilotage-acces-${s.user_id}`} />
          </li>
        ))}
        {!f.liste.length && <li className="p-6 text-center text-sm text-slate-400">Aucun stagiaire</li>}
      </ul>
    </div>
  );
};
